import { FC, ReactElement, useRef } from 'react';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { RecentResultsItemType } from '../../../api/recentResults';
import { GameStatus } from '@pp/core/src/store/slices/game/types';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';
import { useRecentResultDetailStateSlice } from '../../../store/slices/recentResultDetail/selectors';

import styles from './DateTime.module.css';

export interface DateTimeProp {
  index: number;
}

export const DateTime: FC<DateTimeProp> = ({ index }): ReactElement => {
  const formattedDate = useRef('');
  const formattedTime = useRef<React.ReactNode>(null);
  const timeStamp = useRecentResultDetailStateSlice.getTimeStamp();
  const clickedTab = useRecentResultDetailStateSlice.getHashModalData().clickedTab;
  let totalResults: number = useHighflyerGameStateSlice.recentResultsCount();
  const isGameCancelled = useGameStateSlice.getCurrentStatus() === GameStatus.GameCancelled;

  let details: RecentResultsItemType | undefined;

  const formatDateTime = (value: Date) => {
    formattedDate.current = value.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/[\/-]/g, '.');
    formattedTime.current = value.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', });
  }

  if (clickedTab !== 'footer') {
    formatDateTime(new Date(timeStamp));
  } else if (index >= 0 && clickedTab === 'footer') {
    if (index < totalResults) {
      details = useHighflyerGameStateSlice.recentResults()?.history[index];
    }
    if (details) {
      formatDateTime(new Date(details.resultTime));
    }
  } else {
    formattedTime.current = isGameCancelled ? <L10nText tk={'GAMECANCELLED'} /> : <L10nText tk="CURRENT_GAME_CAPS" />;
  }

  return (
    <div className={styles.modalDateTime}>
      {index === -1 ? (
        <span>{formattedTime.current}</span>
      ) : (
        <>
          <span className={styles.modalDate}>{formattedDate.current}</span>
          <span className={styles.modalTime}>{formattedTime.current}</span>
        </>
      )}
    </div>
  );
};
